/**
 * Pastille de rôle — organisation (nomenclature D3 : `proprietaire`/`administrateur`/
 * `facturation`/`editeur`/`lecteur`) ou équipe/projet (`owner`/`admin`/`member`/`viewer`) :
 * ce composant sert les deux univers, dont les codes ne se recoupent plus.
 *
 * Le libellé est TOUJOURS écrit en toutes lettres à côté de la pastille : la couleur ne
 * porte jamais seule l'information (design system §9, piège du daltonisme). Les clés sont
 * des littéraux dans l'objet ci-dessous — le gate `keys.test.js` ne voit pas `t(variable)`.
 */

import { useTranslation } from 'react-i18next';
import { TAG } from '../ui/theme.js';

const ROLE_LABEL_KEYS = {
  proprietaire: 'roleBadge.proprietaire',
  administrateur: 'roleBadge.administrateur',
  facturation: 'roleBadge.facturation',
  editeur: 'roleBadge.editeur',
  lecteur: 'roleBadge.lecteur',
  owner: 'roleBadge.owner',
  admin: 'roleBadge.admin',
  member: 'roleBadge.member',
  viewer: 'roleBadge.viewer',
};

/** Seuls les rôles à droits d'administration sont mis en avant à l'accent. */
const EMPHASISED_ROLES = new Set(['proprietaire', 'administrateur', 'owner', 'admin']);

export function RoleBadge({ role }) {
  const { t } = useTranslation();
  const key = ROLE_LABEL_KEYS[role];
  return (
    <span
      className={`${TAG} ${
        EMPHASISED_ROLES.has(role)
          ? 'border-accent-trait bg-accent-wash text-accent-ink'
          : 'border-line text-ink-soft'
      }`}
    >
      {key ? t(key) : role}
    </span>
  );
}
